import { render, staticRenderFns } from "./discover.vue?vue&type=template&id=27c6171e&"
import script from "./discover.vue?vue&type=script&lang=js&"
export * from "./discover.vue?vue&type=script&lang=js&"
import style0 from "./discover.vue?vue&type=style&index=0&id=27c6171e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports